define(['angular', 'jquery'], function (angular, $) {
    'use strict';

    return angular
        .module('infusionsoftDirectives', [])
        .directive('trackEmail', [
            '$http',
            '$rootScope',
            function ($http, $rootScope) {
                return {
                    restrict: 'A',
                    link: function (scope, element, attrs) {
                        $(element).on('blur', function (e) {
                            var email = $(this).val();
                            $http.post(
                                $rootScope.Routing.generate('track_user'),
                                {
                                    email: email,
                                }
                            );
                        });
                    },
                };
            },
        ]);
});
